// extracted by mini-css-extract-plugin
export default {"popconfirmTitle":"AdditionalFileModal_popconfirmTitle__7fkTZ"};